export default __webpack_public_path__ + "static/media/scatterfoes.ce576115.png";